export const _initialState = {
  expandedRow: undefined,
  currency: undefined,
  loading: true,
  updateTableLoading: true,
  currentPage: 1,
  previouslyVisited: [1],
  perPageFilter: 10,
  directMerchant: {
    orderByCreatedAtState: 0,
    orderByMerchantNameState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0,
    orderByType: null
  },
  partners: {
    orderByCompanyNameState: 0,
    orderByNumMerchantsState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0,
    orderByType: null
  },
  failedLoad: false,
  activeTable: 'Direct Merchants'
};

export const _expandDirectMerchantRow = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    expandedRow:
      action.id === state.directMerchant.expandedRow ? undefined : action.id
  }
});

export const _expandPartnersRow = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    expandedRow:
      action.id === state.directMerchant.expandedRow ? undefined : action.id
  }
});

export const _updateLoadCommissionShow = state => ({
  ...state,
  updateTableLoading: true,
  // Should we reset on toggle?
  directMerchant: {
    ...state.directMerchant,
    orderByCreatedAtState: 0,
    orderByMerchantNameState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0,
    orderByType: null
  },
  partners: {
    ...state.partners,
    orderByCompanyNameState: 0,
    orderByNumMerchantsState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0,
    orderByType: null
  }
});

export const _setCommissionShow = (state, action) => ({
  ...state,
  summary: action.summary,
  directMerchant: {
    ...state.directMerchant,
    ...action.directMerchant
  },
  paginatorTotal: Math.ceil(action.directMerchant.commissions_count / 10),
  loading: false,
  updateTableLoading: false,
  selectedIso: action.selectedIso
});

export const _setCommissionDirectMerchants = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...action.directMerchant
  },
  loading: false,
  updateTableLoading: false,
  failedLoad: false,
  activeTable: 'Direct Merchants'
});

export const _setCommissionPartners = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...action.partners
  },
  loading: false,
  updateTableLoading: false,
  failedLoad: false,
  activeTable: 'Partners'
});

export const _commissionShowFailed = state => ({
  ...state,
  failedLoad: true
});

export const _commissionUpdateShowFailed = state => ({
  ...state,
  failedUpdateLoad: true
});

export const _changePage = (state, action) => ({
  ...state,
  currentPage: action.params.page,
  expandedRow: null,
  previouslyVisited: state.previouslyVisited.includes(action.params.page)
    ? state.previouslyVisited
    : [...state.previouslyVisited, action.params.page]
});

export const _setPerPageFilter = (state, action) => ({
  ...state,
  perPageFilter: action.perPageFilter,
  expandedRow: null,
  previouslyVisited: [1],
  currentPage: 1
});

export const _setPaginatorTotal = (state, action) => ({
  ...state,
  paginatorTotal: action.paginatorTotal
});

const orderPartners = (orderedState, action) => {
  const obj = {
    orderByCompanyNameState: 0,
    orderByNumMerchantsState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0
  };
  return order(obj, orderedState, action);
};

const orderMerchants = (orderedState, action) => {
  const obj = {
    orderByCreatedAtState: 0,
    orderByMerchantNameState: 0,
    orderByProcessingVolumeState: 0,
    orderByTransactionFeeState: 0,
    orderByCommissionState: 0
  };
  return order(obj, orderedState, action);
};

const order = (obj, orderedState, action) => {
  obj[orderedState] = action.orderByState;
  return obj;
};

export const _orderByDirectMerchantsCreatedAt = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...orderMerchants('orderByCreatedAtState', action),
    orderByType: 'created_at'
  }
});
export const _orderByDirectMerchantsMerchantName = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...orderMerchants('orderByMerchantNameState', action),
    orderByType: 'merchant_name'
  }
});

export const _orderByDirectMerchantsProcessingVolume = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...orderMerchants('orderByProcessingVolumeState', action),
    orderByType: 'transaction_amount'
  }
});

export const _orderByDirectMerchantsTransactionFee = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...orderMerchants('orderByTransactionFeeState', action),
    orderByType: 'transaction_fee'
  }
});

export const _orderByDirectMerchantsCommission = (state, action) => ({
  ...state,
  directMerchant: {
    ...state.directMerchant,
    ...orderMerchants('orderByCommissionState', action),
    orderByType: 'revenue_share'
  }
});

export const _orderByPartnersCompanyName = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...orderPartners('orderByCompanyNameState', action),
    orderByType: 'company_name'
  }
});

export const _orderByPartnersNumMerchants = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...orderPartners('orderByNumMerchantsState', action),
    orderByType: 'merchant_count'
  }
});

export const _orderByPartnersProcessingVolume = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...orderPartners('orderByProcessingVolumeState', action),
    orderByType: 'transaction_amount_sum'
  }
});

export const _orderByPartnersTransactionFee = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...orderPartners('orderByTransactionFeeState', action),
    orderByType: 'transaction_fee_sum'
  }
});

export const _orderByPartnersCommission = (state, action) => ({
  ...state,
  partners: {
    ...state.partners,
    ...orderPartners('orderByCommissionState', action),
    orderByType: 'revenue_share_sum'
  }
});
